<template>
    <overlay-modal class="without-header" ref="overlayModal">
        <template v-slot:header>
            <div>
                <h4 class="cursive mb-0" style="line-height: 40px;">{{isTrasferimento? 'Trasferimenti' : 'Attività'}}</h4>
                <div class="d-flex justify-content-between p-2">
                    <div>
                        <span class="text-uppercase" style="line-height: 32px">{{listFiltered.length}} {{isTrasferimento? 'trasferimenti trovati' : 'attività trovate'}}</span>
                    </div>
                    <div>
                        <button v-if="mode === 1" class="btn btn-secondary btn-sm py-1 px-4" href="javascript:void(0)" @click="mode = 2">
                            <img src="../../../../assets/images/svg/white/icone_mappa.svg" height="24px"/>
                            <span class="text-uppercase">mappa</span>
                        </button>
                        <button v-if="mode === 2" class="btn btn-secondary btn-sm py-1 px-4" href="javascript:void(0)" @click="mode = 1">
                            <img src="../../../../assets/images/svg/white/icone_lista.svg" height="24px"/>
                            <span class="text-uppercase">lista</span>
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <template>
            <div class="modal-map">
                <div>
                    <div v-if="mode === 1">
                        <div :style="`height: ${windowHeight}px;`" class="tasks pb-5">
                            <div v-for="(item, index) in listFiltered" :key="index" @mouseover="onMouseHover(item)">
                                <ServicePanel :is-trasferimento="isTrasferimento" :is-from-modal-map="true" :value="item" class="mb-3" :selected="isSelected(item)" @select="onSelectService" @detail="onShowDetail"/>
                            </div>
                        </div>
                    </div>
                    <div v-show="mode === 2" class="p-0">
                        <GmapMap ref="mapRef" :options="{
                               zoomControl: true,
                               mapTypeControl: false,
                               scaleControl: true,
                               streetViewControl: true,
                               rotateControl: true,
                               fullscreenControl: true,
                               disableDefaultUi: false}" :center="center" :zoom="zoom" map-type-id="terrain" class="map" :style="`height: ${windowHeight-70-63}px;`">
                            <gmap-custom-marker :offsetY="-10" :key="index" v-for="(m, index) in markers" :z-index="m.zIndex" @click.native="onSelectMarker(m)" :marker="m" alignment="top">
                                <CustomServiceMarker :value="m" :hover="selectedItem" />
                            </gmap-custom-marker>
                        </GmapMap>
                    </div>
                </div>
            </div>
            <div>
                <ModalServiceDetail v-if="selectedItem" :is-trasferimento="isTrasferimento" ref="modalServiceDetail" :value="selectedItem" @change="onChangeServiceGroup" />
            </div>
        </template>
        <template v-slot:footer>
            <div class="menu-footer d-flex justify-content-between bg-dark">
                <div class="d-flex justify-content-between px-2 py-1">
                    <div @click="onOpenCloseFilter">
                        <p class="mb-0" style="line-height: 30px"><b>Filtra risultati</b><span> | {{counter}}</span></p>
                    </div>
                    <div>
                        <button class="btn btn-sm btn-secondary mt-1" @click="onResetFilter" :disabled="isDisabledReset">reset</button>
                    </div>
                    <div @mouseleave="openFilter = false">
                        <DropdownFilterService :is-trasferimento="isTrasferimento" v-show="openFilter" :list="list" :value="getFilter" @close="onOpenCloseFilter"/>
                    </div>
                </div>
                <div>
                    <CustomOrderSelect :list="order" class="lg" @change="onChangeOrder"/>
                </div>
            </div>
        </template>
    </overlay-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { vueWindowSizeMixin } from 'vue-window-size'
import OverlayModal from '../../../modals/OverlayModal'
import TimeRangeSlider from '../TimeRangeSlider'
import ServicePanel from '../ServicePanel'
import CustomOrderSelect from '../CustomOrderSelect'
import ShowMore from '../ShowMore'
import {LATITUDE, LONGITUDE} from '../../../../utils/config'
import DropdownFilterService from '../dropdown/DropdownFilterService'
import {defaultFiltererServizi, defaultSortererServizi} from '../../../../utils/serviziUtils'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import CustomServiceMarker from '../google-map/CustomServiceMarker'
import ModalServiceDetail from '../../common/modals/ModalServiceDetail'
import AnalyticEvents from '../../../common/AnalyticEvents'

const DEFAULT_BOUND_ZOOM = 12
const DEFAULT_ZOOM = 11

export default {
  name: 'ModalServicesMobileMap',
  mixins: [vueWindowSizeMixin, AnalyticEvents],
  components: {ModalServiceDetail, CustomServiceMarker, GmapCustomMarker, DropdownFilterService, ShowMore, CustomOrderSelect, ServicePanel, TimeRangeSlider, OverlayModal},
  props: {
    list: {
      type: Array,
      default: () => []
    },
    isTrasferimento: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      mode: 1, // 1 list, 2 map
      selectedItem: this.list[0],
      openFilter: false,
      openOrder: false,
      showAll: false,
      center: {lat: LATITUDE, lng: LONGITUDE},
      zoom: DEFAULT_BOUND_ZOOM,
      order: [
        {name: 'prezzo', dir: 'up'},
        {name: 'prezzo', dir: 'down'}
      ]
    }
  },
  computed: {
    counter () {
      return this.listFiltered.length
    },
    getFilter () {
      return this.isTrasferimento ? this.getTrasferimentiFilter() : this.getServiziFilter()
    },
    isDisabledReset () {
      return Object.values(this.getFilter).every(x => x == null)
    },
    getOrder () {
      return this.isTrasferimento ? this.getTrasferimentiOrder() : this.getServiziOrder()
    },
    listFiltered () {
      const list = this.list.filter(this.filterer).sort(this.sorterer)
      const listDaSpingere = list.filter(item => item.config && item.config.isDaSpingere)
      return listDaSpingere.concat(list.filter(item => !(item.config && item.config.isDaSpingere)))
    },
    markers () {
      const list = this.listFiltered
      const listToReturn = list.filter(item => item.anagrafica.element.places[0] && item.anagrafica.element.places[0].coordinate).map((item) => {
        const firstDayPrice = item.pricesByDay[0].prices.map(item => item.venditaTotaleEuro).reduce((t, c) => t + c)
        const selected = this.isSelected(item)
        const zIndex = selected ? 1 : -1
        const firstPlace = item.anagrafica.element.places[0]
        if (firstPlace && firstPlace.coordinate) {
          const {latitude, longitude} = firstPlace.coordinate
          return {name: item.anagrafica.element.name, lat: latitude, lng: longitude, selected, price: firstDayPrice, item, zIndex, hover: false}
        }
      })
      return listToReturn
    }
  },
  methods: {
    ...mapGetters(['getTrasferimentiFilter', 'getServiziFilter', 'getTrasferimentiOrder', 'getServiziOrder', 'resetTrasferimentoFilter', 'resetServiziFilter', 'getServiziSelected', 'getTrasferimentiSelected', 'getListaServizi', 'getListaTrasferimenti']),
    ...mapActions(['addReplaceServizio', 'modifyServiziFilter', 'resetServiziFilter', 'modifyTrasferimentoFilter', 'resetTrasferimentoFilter', 'modifyServiziOrder', 'modifyTrasferimentoOrder']),
    open: function () {
      this.mode = 1
      this.zoom = DEFAULT_BOUND_ZOOM
      const coords = this.markers.map(item => {
        return {lat: item.lat, lng: item.lng}
      })
      this.$refs.mapRef.$mapPromise.then((map) => {
        const bounds = new window.google.maps.LatLngBounds()
        coords.forEach(c => {
          bounds.extend(c)
        })
        map.panToBounds(bounds)
      })
      this.$refs.overlayModal.open()
    },
    close: function () {
      this.$refs.overlayModal.close()
    },
    onResetFilter: function () {
      if (this.isTrasferimento) {
        this.resetTrasferimentoFilter()
      } else {
        this.resetServiziFilter()
      }
    },
    onOpenCloseFilter () {
      this.openFilter = !this.openFilter
    },
    onOpenOrder: function () {
      this.openOrder = !this.openOrder
    },
    onClickMarker: function (marker) {
      this.center = marker.position
    },
    onSelectService () {
      // perchè si chiuda deve selezionare almeno l'andata ed il ritorno
      // if (this.isTrasferimento && this.getTrasferimentiSelected().length < 2) {
      //   return
      // }
      // this.close()
    },
    onShowDetail (item) {
      this.selectedItem = null
      this.$nextTick(() => {
        this.selectedItem = item
        this.$nextTick(() => {
          this.$refs.modalServiceDetail.open(item.groups)
        })
      })
    },
    isSelected (servizio) {
      const list = this.isTrasferimento ? this.getTrasferimentiSelected() : this.getServiziSelected()
      return list.some(item => {
        return servizio.detail.productID === item.detail.productID
      })
    },
    onMouseHover (item) {
      if (this.selectedItem !== item) {
        this.selectedItem = item
        this.markers.forEach(marker => {
          if (marker.item.detail.productID === this.selectedItem.detail.productID) {
            marker.hover = true
            marker.zIndex = 3
          } else {
            marker.zIndex = -1
          }
        })
        const firstPlace = this.selectedItem.anagrafica.element.places[0]
        if (firstPlace && firstPlace.coordinate) {
          const {latitude, longitude} = firstPlace.coordinate
          this.$refs.mapRef.$mapPromise.then((map) => {
            this.zoom = DEFAULT_ZOOM
            map.panTo({lat: latitude, lng: longitude})
          })
        }
      }
    },
    onSelectMarker (marker) {
      this.onShowDetail(marker.item)
    },
    filterer (item) {
      return defaultFiltererServizi(item, this.getFilter)
    },
    sorterer (a, b) {
      return defaultSortererServizi(a, b, this.getOrder)
    },
    onChangeOrder: function (order) {
      if (this.isTrasferimento) {
        this.modifyTrasferimentoOrder({prezzo: order.dir})
      } else {
        this.modifyServiziOrder({prezzo: order.dir})
      }
    },
    onChangeServiceGroup (groups) {
      this.close()
      this.groupsSelected = groups
      const payload = {...this.selectedItem, groups: [...this.groupsSelected]}
      this.addReplaceServizio(payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/modals/ModalServicesMobileMap.vue